import { CONTEXT_TABLE_NAME } from '../constants';
import { SupabaseContext } from '../supabase';
import { type Database } from '../supabase/schema';
import { useInvalidateProcesses } from './useInvalidateProcesses';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

type Context = Database['public']['Tables']['context_records']['Insert'];

export const useContextCreate = () => {
  const context = useContext(SupabaseContext);
  const invalidateProcesses = useInvalidateProcesses();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: async (parameters: {
      data: Context;
      processParentId?: null | string;
    }) => {
      const { data, processParentId } = parameters;
      let response;

      if (context) {
        response = await context?.supabase
          .from(CONTEXT_TABLE_NAME)
          .insert(data)
          .select('id');
        if (response && !response.error) {
          invalidateProcesses(processParentId);
          queryClient.invalidateQueries({
            queryKey: ['process', data.process_id],
          });
          return {
            error: null,
            id: response.data[0].id,
          };
        }
      }

      return {
        error: response?.error?.message || 'Unknown error',
      };
    },
  });

  return { createContextRecord: mutateAsync };
};
